import { Injectable } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import { Effect, Actions } from '@ngrx/effects';

import * as adActions from './ad.actions';
import { Observable } from 'rxjs/Observable';
import { AdService } from '../ad.service';
import { AdItem } from '../ad-item';
import { SalesInfoAddComponent } from '../sales-info-adds-component';

@Injectable()
export class AdEffects {

  constructor(
    private adService: AdService,
    private actions$: Actions
  ) { }

  @Effect()
  loadProducts$: Observable<adActions.AdAction> = this.actions$
    .ofType(adActions.LOAD_ADS)
    .switchMap(() => {
      return this.adService.getAds()
        .map(ads => {
          const adsUpdated = [];
          ads.map(add => {
            if (add.image) {
              adsUpdated.push(new AdItem(SalesInfoAddComponent, {
                src: `url(${add.image})`
              }));
            }
          });
          return new adActions.LoadAdsSuccessAction(adsUpdated);
        });
    }
    );
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/adds/store/ad.effects.ts